import styled from "styled-components";

export const PopoverToggle = styled.div`
  display: flex;
  width: 320px;
  height: 36px;
  padding: 0;
  border: none;
  background: none;

  @media screen and (max-width: 1025px) {
    width: 100%;
    height: 36px;
    padding: 0;
  }
`;
